const s = {
  name: "Chip3",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M27,5V0h-2v5H27z"/>
		<path class="st0" d="M27,13H13v14h14V13z M15,25V15h10v10H15z"/>
		<path class="st0" d="M33,7H7v26h26V7z M9,31V9h22v22H9z"/>
		<path class="st0" d="M27,35v5h-2v-5H27z"/>
		<path class="st0" d="M33,40v-5h-2v5H33z"/>
		<path class="st0" d="M9,35v5H7v-5H9z"/>
		<path class="st0" d="M21,40v-5h-2v5H21z"/>
		<path class="st0" d="M15,35v5h-2v-5H15z"/>
		<path class="st0" d="M33,0v5h-2V0H33z"/>
		<path class="st0" d="M9,5V0H7v5H9z"/>
		<path class="st0" d="M21,0v5h-2V0H21z"/>
		<path class="st0" d="M15,5V0h-2v5H15z"/>
		<path class="st0" d="M35,13h5v2h-5V13z"/>
		<path class="st0" d="M40,7h-5v2h5V7z"/>
		<path class="st0" d="M35,31h5v2h-5V31z"/>
		<path class="st0" d="M40,19h-5v2h5V19z"/>
		<path class="st0" d="M35,25h5v2h-5V25z"/>
		<path class="st0" d="M5,13H0v2h5V13z"/>
		<path class="st0" d="M0,7h5v2H0V7z"/>
		<path class="st0" d="M5,31H0v2h5V31z"/>
		<path class="st0" d="M0,19h5v2H0V19z"/>
		<path class="st0" d="M5,25H0v2h5V25z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Chip3
};
